import DrCastillo from "/img/laboratory/collaborators/DrCastillo.png";
import DrJohan from "/img/laboratory/collaborators/DrJohan.jpeg";
import DrQuijano from "/img/laboratory/collaborators/DrQuijano.png";
import DrAgustin from "/img/laboratory/collaborators/DrAgustin.png";

export type SocialLinks = {
  linkedin?: string;
  github?: string;
  researchgate?: string;
};

export type Researcher = {
  image: string;
  name: string;
  roleKey: string;
  roleColor: string;
  badge: string;
  descriptionKey: string;
  cvUrl?: string;
  email?: string;
  specialtyKeys?: string[];
  socialLinks?: SocialLinks;
};

export const researchers: Researcher[] = [
  {
    image: DrCastillo,
    name: "Dr. Alejandro Castillo Atoche",
    roleKey: "investigador_castillo_role",
    roleColor: "bg-amber-500",
    badge: "SNI II",
    descriptionKey: "investigador_castillo_desc",
    email: "acastill@correo.uady.mx",
    cvUrl: "https://www.linkedin.com/in/alejandro-castillo-atoche-80840b156/",
    specialtyKeys: ["spec_ia", "spec_iot", "spec_redes"],
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/alejandro-castillo-atoche-80840b156/",
      github: "https://github.com",
      researchgate: "https://www.researchgate.net/profile/Alejandro-Castillo-Atoche-2",
    },
  },
  {
    image: DrJohan,
    name: "Dr. Johan Estrada López",
    roleKey: "investigador_johan_role",
    roleColor: "bg-blue-500",
    badge: "SNI I",
    descriptionKey: "investigador_johan_desc",
    email: "johan.estrada@correo.uady.mx",
    cvUrl: "https://www.linkedin.com/in/johan-estrada/",
    specialtyKeys: ["spec_vlsi", "spec_iot", "spec_energia"],
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/johan-estrada/",
      researchgate: "https://www.researchgate.net/profile/Johan-Estrada-Lopez",
    },
  },
  {
    image: DrQuijano,
    name: "Dr. Renán Quijano",
    roleKey: "investigador_quijano_role",
    roleColor: "bg-green-600",
    badge: "SNI I",
    descriptionKey: "investigador_quijano_desc",
    email: "renan.quijano@correo.uady.mx",
    cvUrl: "https://www.linkedin.com/in/ren%C3%A1n-quijano-5b2169103/",
    specialtyKeys: ["spec_instrumentacion", "spec_potencia"],
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/ren%C3%A1n-quijano-5b2169103/",
      researchgate: "https://www.researchgate.net/profile/Renan-Quijano-Cetina",
    },
  },
  {
    image: DrAgustin,
    name: "Dr. José Hernández Benítez",
    roleKey: "investigador_hernandez_role",
    roleColor: "bg-purple-600",
    badge: "PhD",
    descriptionKey: "investigador_hernandez_desc",
    email: "jose.hernandez@correo.uady.mx",
    cvUrl: "https://scholar.google.com",
    specialtyKeys: ["spec_senales", "spec_energia", "spec_iot"],
    socialLinks: {
    },
  },
];